import { render, staticRenderFns } from "./Skip10ForwardIcon.vue?vue&type=template&id=3b5e512d"
import script from "./Skip10ForwardIcon.vue?vue&type=script&lang=js"
export * from "./Skip10ForwardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports